import api, { cardeal } from './api';

export class DadosPessoaisService {
  getDadosPessoais = (matricula) => {
    return cardeal.get('ObterDadosPessoaisParticipante', {
      params: {
        matricula,
      },
    });
  };

  getDadosPessoaisSAP = (matricula, token) =>
    api.get(`ObterSAPDadosPessoais?matricula=${matricula}&token=${token}`);

  atualizarSAPDadosPessoais = async (values) => {
    const params = {
      ...values,
      cep: values.cep.replace(/\./g, ''),
    };
    const response = await api.post('AtualizarSAPDadosPessoais', params);
    return response;
  };

  /**
   * Função para realizar a atualização cadastral de dados pessoais no SAP.
   * Envia os dados alterados junto com informações adicionais para uma API.
   *
   * @param {Object} dadosCadastraisAlterados - Os dados cadastrais que foram alterados no sistema.
   * @param {Object} dadosCadastraisSAPAlterados - Os dados cadastrais correspondentes alterados no SAP.
   * @param {string} matricula - A matrícula do participante, usada para identificar o registro.
   * @param {string} token - O token de autenticação, necessário para realizar a chamada à API.
   * @param {boolean} fluxo - Indica se a operação segue um fluxo direto (true) ou não (false).
   * @returns {Promise<Object>} Resposta da API com os resultados da atualização.
   */
  atualizacaoCadastral = async (
    dadosCadastraisAlterados,
    dadosCadastraisSAPAlterados,
    matricula,
    token,
    fluxo
  ) => {
    const params = {
      dadosCadastraisAlterados,
      dadosCadastraisSAPAlterados,
      matricula,
      token,
      isFluxoDireto: fluxo,
    };

    const response = await api.post(`AtualizarSAPDadosPessoais`, params);

    return response;
  };
}
